import styled from 'styled-components';
import { BUTTON_SIZES, BUTTON_VARIANTS, RefreshButton } from 'ui/button';
import { DiscardedEmptyState } from 'ui/illustrations';

import { useTranslation } from '../../hooks';

const Wrapper = styled.div<{ isSection: boolean }>`
  ${({ isSection }) => (isSection ? 'grid-column: 1 / span 4' : '')};
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;
  justify-content: center;
`;

const Title = styled.div`
  color: ${({ theme }) => theme.colors.textColors.textPrimary};
  font-size: 16px;
  font-weight: 600;
  margin: 20px 0;
`;

const Description = styled.div`
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 20px;
  text-align: center;
`;

type AudienceInsightsErrorProps = {
  refresh: () => void;
  isRefreshing: boolean;
  isSection: boolean;
};

export const ErrorMessage = ({ refresh, isRefreshing, isSection }: AudienceInsightsErrorProps) => {
  const { t } = useTranslation();

  return (
    <Wrapper isSection={isSection}>
      <DiscardedEmptyState />
      <Title>{t('insights.errorBoundary.title')}</Title>
      <Description>
        {t('insights.errorBoundary.subtitle')}
        <br />
        {t('insights.errorBoundary.description')}
      </Description>
      <RefreshButton
        onClick={refresh}
        isRefreshing={isRefreshing}
        isDisabled={isRefreshing}
        variant={BUTTON_VARIANTS.PRIMARY}
        size={BUTTON_SIZES.MEDIUM}
      >
        {t(`insights.errorBoundary.${isRefreshing ? 'loadingMessage' : 'callToAction'}`)}
      </RefreshButton>
    </Wrapper>
  );
};
